import { createPinia } from "pinia";
import { initFilters } from "./filter/init";
import mitt from 'mitt';
import maska from "maska";

import { createApp } from 'vue';
import App from './App.vue';

import store from './store';
import TheCartWidget from "./components/cart/TheCartWidget.vue";
import TheCartWidgetMobile from "./components/cart/TheCartWidgetMobile.vue";
import TheCartPage from "./components/cart/TheCartPage.vue";
import TheNotification from "./components/notification/TheNotification.vue";
import TheCartFinish from "./components/cart/TheCartFinish.vue";
import TheCartAddedProduct from "./components/cart/TheCartAddedProduct.vue";
import TheFavoritesWidget from "./components/favorites/TheFavoritesWidget.vue";
import TheCompareWidget from "./components/favorites/TheCompareWidget.vue";
import TheMarkups from "./components/markups/TheMarkups.vue";

const pinia = createPinia();
initFilters(pinia);

const emitter = mitt();

if (document.querySelector('#app')) {
    const app = createApp(App);
    app.mount('#app');
}

if (document.querySelector('#markups')) {
    const app = createApp(TheMarkups).use(pinia);
    app.mount('#markups');
}

const cartWidgets = document.querySelectorAll('#cart-widget');
if (cartWidgets.length) {
    cartWidgets.forEach((widget) => {
        const app = createApp(TheCartWidget).use(store);
        app.config.globalProperties.emitter = emitter;
        app.mount(widget);
    });
}

if (document.querySelectorAll('#cart-widget-mobile')) {
    const app = createApp(TheCartWidgetMobile).use(store);
    app.config.globalProperties.emitter = emitter;
    app.mount('#cart-widget-mobile');
}

if (document.querySelector('#cart-page')) {
    const app = createApp(TheCartPage).use(store);
    app.use(maska);
    app.config.globalProperties.emitter = emitter;
    app.mount('#cart-page');
}

if (document.querySelector('#cart-complete')) {
    const app = createApp(TheCartFinish).use(store);
    app.use(maska);
    app.config.globalProperties.emitter = emitter;
    app.mount('#cart-complete');
}

if (document.querySelector('#notifications')) {
    const app = createApp(TheNotification).use(store);
    app.config.globalProperties.emitter = emitter;
    app.mount('#notifications');
}

// Модалка добавляения в корзину
document.addEventListener('DOMContentMutated', () => {
    const addedProduct = document.querySelector('#added-buyable');
    if (addedProduct) {
        const app = createApp(
            TheCartAddedProduct,
            {
                buyableId: addedProduct.dataset.addedBuyableId
            }
        ).use(store);
        app.config.globalProperties.emitter = emitter;
        app.mount('#added-buyable');
    }
});

const favWidgets = document.querySelectorAll('#favorites-widget');
if (favWidgets.length) {
    favWidgets.forEach((widget) => {
        const app = createApp(TheFavoritesWidget).use(store);
        app.config.globalProperties.emitter = emitter;
        app.mount(widget);
    })
}

const compareWidgets = document.querySelectorAll('#compare-widget');
if (compareWidgets.length) {
    compareWidgets.forEach((widget) => {
        const app = createApp(TheCompareWidget).use(store);
        app.config.globalProperties.emitter = emitter;
        app.mount(widget);
    })
}

document.addEventListener('cartAdd', (e) => {
    store.dispatch('cart/add', e.detail);
});

document.addEventListener('favoritesAdd', (e) => {
    store.dispatch('favorites/add', e.detail);
});

document.addEventListener( 'favoritesRemove', (e) => {
    store.dispatch('favorites/remove', e.detail);
});

document.addEventListener('compareAdd', (e) => {
    store.dispatch('compare/add', e.detail);
});

document.addEventListener( 'compareRemove', (e) => {
    store.dispatch('compare/remove', e.detail);
});